<div class="container" style="padding-top: 50px;background-color: white;">
    <iframe [src]="url | safe: 'resourceUrl'" frameborder="0" scrolling="yes" seamless="seamless" style="display:block; width:100%; height:100vh;" height="100%" width="100%"></iframe>
</div>